<template>
     <div>
          <div class="display-3 text-center font-weight-thin pt-12" :style="'color: ' +  contentFontMain">Immobilien richtig verkaufen!</div>
          <div class="headline text-center font-italic py-6 mb-6" :style="'color: ' +  contentFontSecond">Kostenlose Verkaufsempfehlungen von passenden Marklern erhalten.</div>
          <v-carousel 
               v-model="model"
               :show-arrows="true"
               :show-arrows-on-hover="true"
               :hide-delimiters="true"
               :continuous="false"
          >
               <slide 
                    v-for="(slide, index) in Slides" 
                    :textAndImageArray="Slides[index]" 
                    :question="Questions[index]" 
                    :sliderQuestionBG="sliderQuestionBG"
                    :sliderFontQuestion="sliderFontQuestion"
                    :sliderFontCards="sliderFontCards"
                    :sliderCardTop="sliderCardTop"
                    :sliderCardBottom="sliderCardBottom" 
                    :sliderCardBorderDefault="sliderCardBorderDefault" 
                    :sliderCardBorderSelected="sliderCardBorderSelected">
               </slide>

          </v-carousel>
          <v-progress-linear class="bottomBar" :value="(this.model+1)*50" :color="progressBar"></v-progress-linear>
     </div>
</template>

<script>
import Slide from './Slide.vue';

export default {
     name: 'Content',
     components: {
          Slide
     },
     props: {
          Slides: {
               type: Array,
               required: true
          },
          Questions: {
               type: Array,
               required: true
          },
          contentFontMain: {
               type: String,
               required: true
          },
          contentFontSecond: {
               type: String,
               required: true
          },
          sliderQuestionBG: {
               type: String,
               required: true
          },
          sliderFontQuestion: {
               type: String,
               required: true
          },
          sliderFontCards: {
               type: String,
               required: true
          },
          sliderCardTop: {
               type: String,
               required: true
          },
          sliderCardBottom: {
               type: String,
               required: true
          },
          sliderCardBorderDefault: {
               type: String,
               required: true
          },
          sliderCardBorderSelected: {
               type: String,
               required: true
          },
          progressBar: {
               type: String,
               required: true
          },
     },
     data: () => ({
          model: 0,
     }),
     methods: {

     },
     created() {
          Event.$on('cardClicked', () => setTimeout(() => this.model = 1, 700));
     }
};
</script>

<style>
  .bottomBar {
     position: absolute;
     bottom: 0;
  }
</style>
